import styled from 'styled-components';
import { getColor } from '@karma/components/colors';

export const InfoPageLinkSubtitle = styled.span`
  font-weight: 600;
  font-size: 20px;
  color: ${getColor('primary1')};

  @media (max-width: 440px) {
    font-size: 16px;
  }
`;
